// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';

// Custom packages - Component
import { StatsListComponent } from 'src/app/modules/stats/pages/stats-list/stats-list.page';

const routes: Routes = [
  {
    path: 'list',
    component: StatsListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadStats']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class StatsRoutingModule { }
